<script lang="ts">
  import Password from "$app/components/Password.svelte"

  let { errors }: { errors: Record<string, any> } = $props()

  const INITIAL_FORM = {
    email: "",
    name: "",
    password: "",
    email_optin: false
  }
  let userForm = $state({ ...INITIAL_FORM })

  export function getData() {
    return {
      name: userForm.name,
      email: userForm.email,
      password: userForm.password,
      email_optin: userForm.email_optin
    }
  }
</script>

<h2 class="text-xl font-bold text-gray-500">Your Account Details</h2>

<div class="input-cont mt-4" class:error={errors.email}>
  <label for="email" class="block text-sm font-medium text-gray-700">
    Email address
  </label>
  <div class="mt-1">
    <input
      id="email"
      name="user[email]"
      type="email"
      required
      class="input rounded-md"
      placeholder="john@example.com"
      bind:value={userForm.email}
    />
  </div>
  <div class="msg">{errors.email}</div>
</div>

<div class="input-cont mt-4" class:error={errors.name}>
  <label for="email" class="block text-sm font-medium text-gray-700">
    Your full name
  </label>
  <div class="mt-1">
    <input
      id="full_name"
      name="user[name]"
      type="text"
      required
      class="input rounded-md"
      placeholder="John Doe"
      bind:value={userForm.name}
    />
  </div>
  <div class="msg">{errors.name}</div>
</div>

<div class="input-cont mt-4" class:error={errors.password}>
  <label for="password" class="block text-sm font-medium text-gray-700">
    Password
  </label>
  <div class="mt-1">
    <Password
      id="password"
      name="user[password]"
      bind:value={userForm.password}
      class="input rounded-md"
      required={true}
      placeholder="********"
    />
  </div>
  <div class="msg">{errors.password}</div>
</div>

<div class="input-cont mt-4">
  <label for="email_optin" class="flex items-center gap-1 text-sm">
    <input
      type="checkbox"
      id="email_optin"
      bind:checked={userForm.email_optin}
      name="user[email_optin]"
      required
    />
    <div class="ml-1">
      Yes, sign me up to receive the latest news from Lead with Purpose
    </div>
  </label>
</div>
